<div class="auth-container">
  <div class="auth-body">
    <form
      class="form-container"
      (ngSubmit)="onChangeFirstTimePassword()"
      [formGroup]="firstTimeLoginForm"
      autocomplete="off"
      >
      <div class="centered">
        <img
          src="../../../../assets/logos/insite-logo.png"
          class="insite-everywhere-logo"
          />
        </div>
        <div class="centered column-direction">
          <span i18n="@@createNewPasswordTitle" class="auth-title"
            >Create New Password</span
            >
            <span
              i18n="@@firstTimeLoginDescription"
              class="first-time-login-description body-large"
              >
          Please create a new password after your first time login. Your
          provided temporary password will expire in 7 days.
        </span>
            <span
              class="auth-error-message error-message"
          [style.visibility]="
            (authService.authServiceError$ | async) != '' ? 'visible' : 'hidden'
          "
              >
              {{ authService.authServiceError$.value }}
            </span>
          </div>
          <div class="auth-input-fields">
            <div class="first-time-login-control">
              <mat-form-field appearance="outline" hideRequiredMarker="true">
                <mat-label i18n="@@newPasswordLabel">New password</mat-label>
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="password"
                  placeholder="New password"
                  i18n-placeholder="@@newPasswordPlaceholder"
                  />
                  <mat-icon matSuffix (click)="hide = !hide">{{
                    hide ? 'visibility_off' : 'visibility'
                  }}</mat-icon>
                  @if (emptyPassword()) {
                    <mat-error i18n="@@emptyNewPasswordError">
              Please enter your new password
            </mat-error>
                  }
                </mat-form-field>
              </div>
              <div
                class="first-time-login-control"
                [style.margin-bottom]="invalidConfirmPassword() ? '10px' : '25px'"
                >
                <mat-form-field appearance="outline" hideRequiredMarker="true">
                  <mat-label i18n="@@confirmNewPasswordLabel"
                    >Confirm new password</mat-label
                    >
                    <input
                      matInput
                      [type]="hideConfirm ? 'password' : 'text'"
                      formControlName="confirmPassword"
                      placeholder="Confirm new password"
                      i18n-placeholder="@@confirmNewPasswordPlaceholder"
                      />
                      <mat-icon matSuffix (click)="hideConfirm = !hideConfirm">{{
                        hideConfirm ? 'visibility_off' : 'visibility'
                      }}</mat-icon>
                      @if (showEmptyConfirmPasswordError()) {
                        <mat-error
                          i18n="@@emptyConfirmPasswordError"
                          >
              Please confirm your password
            </mat-error>
                      }
                    </mat-form-field>
                    <mat-error
                      i18n="@@matchingPasswordError"
                      class="matching-password-error"
                      [style.display]="invalidConfirmPassword() ? 'inherit' : 'none'"
                      >
            Please make sure your passwords match
          </mat-error>
                  </div>
                  <atlas-password-validation-panel
                    [minLengthRequirementAccomplished]="hasMinLength()"
                    [numberRequirementAccomplished]="hasNumber()"
                    [specialCharRequirementAccomplished]="hasSpecialChar()"
                    [upperCaseLetterRequirementAccomplished]="hasUpperCase()"
                    [lowerCaseLetterRequirementAccomplished]="hasLowerCase()"
                  ></atlas-password-validation-panel>
                </div>
                <div class="verify-new-password-control auth-btn-div">
                  <button
                    i18n="@@completeNewPasswordButton"
                    mat-raised-button
                    class="auth-btn"
                    color="primary"
                    type="submit"
                    [disabled]="invalidForm()"
                    >
          Complete new password
        </button>
                </div>
                <div class="back-to-login centered">
                  <span i18n="@@goBackToLogin">Go back to login?</span>
                  <span i18n="@@clickHere" class="link" (click)="onGoBackToLogin()"
                    >Click here</span
                    >
                  </div>
                </form>
              </div>
              <div class="auth-footer">
                <img src="../../../../assets/logos/CACI-logo 1.svg" class="caci-logo" />
              </div>
            </div>
